import { render, staticRenderFns } from "./beneficiary-payment-purpose.vue?vue&type=template&id=1665396e&"
import script from "./beneficiary-payment-purpose.vue?vue&type=script&lang=js&"
export * from "./beneficiary-payment-purpose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports